"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HavenRum = exports.SREAlertType = void 0;
const browser_rum_1 = require("@datadog/browser-rum");
var SREAlertType;
(function (SREAlertType) {
    SREAlertType[SREAlertType["EmailUnsubscribe"] = 0] = "EmailUnsubscribe";
    SREAlertType[SREAlertType["EmailSubscribe"] = 1] = "EmailSubscribe";
})(SREAlertType = exports.SREAlertType || (exports.SREAlertType = {}));
class HavenRum {
    // context will only be defined if the datadog RUM has been started
    static Context() {
        return HavenRum._datadogRumContext;
    }
    // Only starts the datadog RUM if configuraton is set
    static Start(rumInitConfiguration) {
        if (!(rumInitConfiguration.applicationId &&
            rumInitConfiguration.clientToken &&
            rumInitConfiguration.env)) {
            return;
        }
        browser_rum_1.datadogRum.init(rumInitConfiguration);
        browser_rum_1.datadogRum.startSessionReplayRecording();
        HavenRum._datadogRumContext = browser_rum_1.datadogRum;
    }
    static Disable() {
        HavenRum._datadogRumContext = undefined;
    }
    static SendSREAlert(alertType, meta) {
        var _a;
        if (HavenRum._datadogRumContext) {
            const alertTypeString = SREAlertType[alertType];
            (_a = HavenRum._datadogRumContext) === null || _a === void 0 ? void 0 : _a.addError(new Error(alertTypeString), {
                SREAlertType: alertTypeString,
                Meta: meta
            });
        }
    }
}
exports.HavenRum = HavenRum;
